import React from "react";

export const CartLoader = () => (
  <svg className="fl-cart" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle className="fl-cart__drop fl-cart__drop--1" cx="30" cy="6" r="3" fill="#ff8a4c" />
    <circle className="fl-cart__drop fl-cart__drop--2" cx="36" cy="6" r="3" fill="#4caf50" />
    <circle className="fl-cart__drop fl-cart__drop--3" cx="32" cy="6" r="3" fill="#1976d2" />
    <g className="fl-cart__body">
      <path
        d="M6 14h6l4 22h28l4-16H16"
        stroke="#1976d2"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="22" cy="50" r="4" stroke="#1976d2" strokeWidth="2.5" fill="#fff" />
      <circle cx="42" cy="50" r="4" stroke="#1976d2" strokeWidth="2.5" fill="#fff" />
    </g>
  </svg>
);

export const CardScanLoader = () => (
  <svg className="fl-card" width="76" height="52" viewBox="0 0 76 52" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="fl-card-scan-grad" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0" stopColor="#1976d2" stopOpacity="0" />
        <stop offset="0.5" stopColor="#1976d2" stopOpacity="0.9" />
        <stop offset="1" stopColor="#1976d2" stopOpacity="0" />
      </linearGradient>
      <clipPath id="fl-card-clip">
        <rect x="2" y="2" width="72" height="48" rx="6" />
      </clipPath>
    </defs>
    <rect x="2" y="2" width="72" height="48" rx="6" fill="#f5f9ff" stroke="#1976d2" strokeWidth="2" />
    <rect x="9" y="12" width="14" height="10" rx="1.5" fill="#ffc107" />
    <rect x="9" y="32" width="38" height="3" rx="1.5" fill="#1976d2" opacity="0.35" />
    <rect x="9" y="39" width="22" height="3" rx="1.5" fill="#1976d2" opacity="0.35" />
    <g clipPath="url(#fl-card-clip)">
      <rect className="fl-card__scan" x="2" y="2" width="72" height="4" fill="url(#fl-card-scan-grad)" />
    </g>
  </svg>
);

export const HourglassLoader = () => (
  <svg className="fl-hg" width="56" height="68" viewBox="0 0 56 68" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M10 4h36M10 64h36" stroke="#1976d2" strokeWidth="3" strokeLinecap="round" />
    <path d="M10 4 L28 32 L10 64" stroke="#1976d2" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
    <path d="M46 4 L28 32 L46 64" stroke="#1976d2" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
    <path className="fl-hg__top" d="M14 8 L28 30 L42 8 Z" fill="#ffb74d" />
    <path className="fl-hg__bot" d="M28 34 L14 60 L42 60 Z" fill="#ffb74d" />
    <line className="fl-hg__stream" x1="28" y1="32" x2="28" y2="38" stroke="#ffb74d" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const DotsLoader = () => (
  <div className="fl-dots" aria-hidden="true">
    <span className="fl-dots__d" />
    <span className="fl-dots__d" />
    <span className="fl-dots__d" />
  </div>
);

export const LockLoader = () => (
  <svg className="fl-lock" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle className="fl-lock__ring fl-lock__ring--1" cx="32" cy="32" r="20" stroke="#1976d2" strokeWidth="2" fill="none" />
    <circle className="fl-lock__ring fl-lock__ring--2" cx="32" cy="32" r="20" stroke="#1976d2" strokeWidth="2" fill="none" />
    <path
      d="M23 30v-5a9 9 0 0 1 18 0v5"
      stroke="#1976d2"
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
    />
    <rect x="20" y="30" width="24" height="18" rx="3" fill="#1976d2" />
    <circle cx="32" cy="38" r="2.4" fill="#fff" />
    <rect x="31" y="38" width="2" height="6" rx="1" fill="#fff" />
  </svg>
);
